// extracted by mini-css-extract-plugin
module.exports = {"price":"styles_price__O4WZQ","total":"styles_total__JTOO7","caption":"styles_caption__bwjPf","sale":"styles_sale__SF5Z7","partnersWrapper":"styles_partnersWrapper__s3GRX"};